module.exports = require("lodash/defaults");


//////////////////
// WEBPACK FOOTER
// external "lodash/defaults"
// module id = 123
// module chunks = 0 1